module.exports = __webpack_public_path__ + "static/media/geometry.3d6f68ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Create/NewResource/images/geometry.png
// module id = 1202
// module chunks = 2